import { computed, toValue, watch, type MaybeRef } from 'vue'
import { useEventBus } from '@vueuse/core'
import useGet from '@/core/composables/api/useGet'
import type { Objective } from '@/core/composables/use-objectives'
import { EventKey } from '@/core/events/event-key'

export const useArchivedObjectives = (ownerId: MaybeRef<string>) => {
  const objectiveUpdatedBus = useEventBus(EventKey.objectiveUpdated)

  const ownerIdValue = computed(() => toValue(ownerId))

  const { data, load, status, reload } = useGet<ArchivedObjectives>('objectives/archived')

  const query = computed(() => ({
    ownerId: ownerIdValue.value,
  }))

  const loadArchived = () => load({ query: query.value })
  const reloadArchived = () => reload({ query: query.value })

  watch(ownerIdValue, loadArchived, { immediate: true })

  objectiveUpdatedBus.on(() => reloadArchived())

  return {
    data,
    status,
    ownerId: ownerIdValue,
  }
}

export interface ArchivedObjectives {
  readonly objectives: ReadonlyArray<Objective>
}
